export enum LegalChangesRatingId {
  open = 'OPEN',
  done = 'DONE',
  toClarify = 'TO_CLARIFY',
  notApplicable = 'NOT_APPLICABLE',
  noRatingNeeded = 'NO_RATING_NEEDED'
}
